import { ajax } from "rxjs/ajax";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../../../model/Organization";
import { OrganizationUISettings } from "../../../model/OrganizationUISettings";
import { UISettingsSuccessResponse } from "../../../service/api-response/UISettingsSuccessResponse";
import { getAuthAndDefaultHeaders } from "../../../service/apiConsts";

export class ApiOrganization {
  constructor(private apiEndpoint: string) {}

  getUISettings(
    token: string,
    organization: OrganizationKeyName
  ): Observable<UISettingsSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/ui-settings`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  setUISettings(
    token: string,
    organization: OrganizationKeyName,
    data: OrganizationUISettings
  ): Observable<any> {
    return ajax({
      method: "PUT",
      url: `${this.apiEndpoint}/organizations/${organization}/ui-settings`,
      body: data,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
